"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tally = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const tally_style_1 = __importDefault(require("./tally.style"));
class Tally extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => (jsx_runtime_1.jsx("div", Object.assign({ className: this.props.classes.root }, { children: jsx_runtime_1.jsx("div", Object.assign({ className: this.props.classes.constraint }, { children: this.props.value }), void 0) }), void 0));
    }
}
exports.Tally = Tally;
Tally.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    value: prop_types_1.default.number.isRequired,
    // The following props are used in ./tally.style.js
    // eslint-disable-next-line react/no-unused-prop-types
    color: prop_types_1.default.string,
    // eslint-disable-next-line react/no-unused-prop-types
    backgroundColor: prop_types_1.default.string
};
Tally.defaultProps = {
    color: 'grey3',
    backgroundColor: 'grey7'
};
exports.default = react_jss_1.default(tally_style_1.default)(Tally);
//# sourceMappingURL=tally.js.map